<div class="event-details-container flex" *ngIf="selectedEvent">
  <div class="event-details-content">
    <div class="flex flex-m-column">
      <div class="flex">
        <img [src]="'img/logo-klubova/'+selectedEvent.team1Logo" class="team-logo" />
        <span class="separator" *ngIf="selectedEvent.team2Name">VS</span>
        <img *ngIf="selectedEvent.team2Logo" [src]="'img/logo-klubova/'+selectedEvent.team2Logo" class="team-logo" />
      </div>

      <div class="flex flex-column ml-5">
        <ng-container *ngIf="selectedEvent.isGroup">
          <span>
            {{ "EVENT.GROUP_TICKETS" | translate }}
            <ng-container *ngIf="selectedEventAction.membersExclusive">
              {{ "EVENT.EXCLUSIVE_TICKETS_FOR_MEMBERS" | translate }}
            </ng-container>
          </span>
        </ng-container>
        <ng-container *ngIf="!selectedEvent.isGroup">
          <span>
            {{ "EVENT.TICKETS_SALE" | translate }}
            <ng-container *ngIf="selectedEventAction.membersExclusive">
              {{ "EVENT.EXCLUSIVE_TICKETS_FOR_MEMBERS" | translate }}
            </ng-container>
          </span>
        </ng-container>

        
        <span class="event-name">{{ selectedEvent.name }}</span>
        <p class="event-group-name">{{ selectedEvent.eventGroupName }} {{ selectedEvent.comment1 }}</p>
      </div>
    </div>
  
    <div class="event-more-details">
      <div class="event-more-details-column">
        <div class="event-more-details-card">
          <img src="img/icons/location.png" />
          <span class="bold">{{ "COMMON.LOCATION" | translate }}: </span>
          <span>{{ selectedEvent.venueName }}</span>
        </div>
    
        <div class="event-more-details-card" *ngIf="selectedEvent.startTime">
          <img src="img/icons/time.png" />
          <span class="bold">{{ "COMMON.DATE" | translate }}:</span>
          <span>{{ selectedEvent.startTime | date:'dd.MM.yyyy HH:mm':'Europe/Zagreb' }}</span>
        </div>
      </div>
  
      <div class="event-more-details-column">
<!--         <div class="event-more-details-card">
          <img src="img/icons/seats-number.png" />
          <span class="bold">{{ "COMMON.SEATS_NUMBER" | translate }}: </span>
          <span></span>
        </div> -->
      
        <div class="event-more-details-card">
          <img src="img/icons/currency.png" />
          <span class="bold">{{ "COMMON.PRICES" | translate }}: </span>
          <span>
            <ng-container *ngFor="let price of selectedEvent.prices.amounts; let i = index">
              <ng-container *ngIf="i > 0"> / </ng-container>
              {{ price }}
            </ng-container>
            {{ selectedEvent.prices.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>